import { useEffect } from 'react';

const SCROLLABLE_SELECTOR = '[data-allow-scroll]';

const preventScroll = (e: Event) => {
  if (e.target instanceof Element && e.target.closest(SCROLLABLE_SELECTOR)) {
    return;
  }
  e.preventDefault();
};

const disableScrolling = () => {
  window.addEventListener('wheel', preventScroll, { passive: false });
  window.addEventListener('touchmove', preventScroll, { passive: false });
};

const enableScrolling = () => {
  window.removeEventListener('wheel', preventScroll);
  window.removeEventListener('touchmove', preventScroll);
};

const useDisableScroll = (isActive = true) => {
  useEffect(() => {
    if (!isActive) return;

    disableScrolling();

    return () => {
      enableScrolling();
    };
  }, [isActive]);
};

export default useDisableScroll;
